/* tslint:disable */
/* eslint-disable */
/**
 * Car
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Models,
} from '../models';

export interface GetModelsRequest {
    manufacturerId: number;
}

/**
 * 
 */
export class ModelsApi extends runtime.BaseAPI {

    /**
     * Listet alle Modelle auf 
     */
    async getModelsRaw(requestParameters: GetModelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Models>>> {
        if (requestParameters.manufacturerId === null || requestParameters.manufacturerId === undefined) {
            throw new runtime.RequiredError('manufacturerId','Required parameter requestParameters.manufacturerId was null or undefined when calling getModels.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/models/{manufacturerId}`.replace(`{${"manufacturerId"}}`, encodeURIComponent(String(requestParameters.manufacturerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Listet alle Modelle auf 
     */
    async getModels(requestParameters: GetModelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Models>> {
        const response = await this.getModelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
